export enum VersionCompare {
	IDENTICAL_VERSIONS,
	LOCAL_VERSION_HIGHER,
	REMOTE_VERSION_HIGHER
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/version-compare.enum.ts